import { createSignal } from '@verclam/pulsar';

export type LoginStep = { type: 'identification'; email: string } | { type: 'credentials'; email: string };

/**
 * Which of the two steps of the login screen is showing, and the address carried across them — the
 * only state the two steps share. The union makes the invariant structural: there is no way to be on
 * the credentials step without an address.
 */
const loginStepSignal = createSignal<LoginStep>({ type: 'identification', email: '' });

export const goToCredentialsStep = (email: string): void => {
	loginStepSignal.value = { type: 'credentials', email };
};

/** Returns to step 1 without losing what the visitor already typed. */
export const goToIdentificationStep = (email: string): void => {
	loginStepSignal.value = { type: 'identification', email };
};

export const resetLoginStep = (): void => {
	loginStepSignal.value = { type: 'identification', email: '' };
};

export default loginStepSignal;
